export const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL ;

export const REACT_APP_BACKEND_URL_LOGIN = process.env.REACT_APP_BACKEND_URL_LOGIN;
